import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowRightCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M2 16a14 14 0 1 0 28 0 14 14 0 0 0-28 0m15.69-7.69 7 6.89c.204.216.316.503.31.8a1.1 1.1 0 0 1-.31.8l-7 6.89a1.07 1.07 0 0 1-1.5 0 1 1 0 0 1 0-1.48L21.5 17H8a1 1 0 0 1 0-2h13.5l-5.31-5.22a1 1 0 0 1 0-1.48 1.07 1.07 0 0 1 1.5.01"
    />
  </svg>
);
const ForwardRef = forwardRef(IconArrowRightCircleFilledSVG);
ForwardRef.displayName = "IconArrowRightCircleFilled";
export { ForwardRef as IconArrowRightCircleFilled };
